/* global updateCartDisplay, alertMessage, braintree, globalCart, google, findGoogleAddressComponent, number_format */
document.querySelectorAll('[name=checkout_account_type]').forEach(function(el) {
    el.addEventListener('change', function() {
        if (el.value === 'returning') {
            document.querySelector('.login-area.returning-checkout-area').classList.remove('hidden');
            document.querySelector('.login-area.create-account-area').classList.add('hidden');
        } else {
            document.querySelector('.login-area.returning-checkout-area').classList.add('hidden');
            document.querySelector('.login-area.create-account-area').classList.remove('hidden');
        }
    });
});

document.querySelectorAll('[name=checkout_delivery_type]').forEach(function(el) {
    el.addEventListener('change', function(e) {
        var request = new XMLHttpRequest();
        request.open('POST', '/cart/setDeliveryOption', true);
        request.onload = function() {
            if (request.status >= 200 && request.status < 400) {
                var cartResponse = JSON.parse(this.responseText);
                if (cartResponse.status === 'Error') {
                    document.querySelector('#checkout_delivery_pickup').checked = true;
                    e.preventDefault();
                    alert(cartResponse.Error);
                    //return false;
                }
                updateCartDisplay(cartResponse.cartData);
            } else {
                alertMessage('AJAX response error in switching checkout delivery type', request);
            }
        };
        request.error = function() {
            alertMessage('Server response error in switching checkout delivery type', request);
        };

        var changeFD = new FormData();
        changeFD.append('option', 'delivery_type');
        changeFD.append('value', el.value);

        request.send(changeFD);
    });
});

if (document.querySelector('#delivery_delivery_same')) {
    document.querySelector('#delivery_delivery_same').addEventListener('click', function() {
        var checkboxField = this;
        var billingFields = document.querySelectorAll('.billing-area input:not([type=checkbox]), .billing-area select');

        //TODO: Verify that billing fields are filled in before continuing.

        billingFields.forEach(function(el) {
            if (el.required) {
                if (el.value.trim().length === 0) {
                    //var relatedField = document.querySelector("label[for=" + el.id + "]");
                    return;
                }
                /* show error and fail */
            }
        });

        if (checkboxField.checked) {
            document.querySelectorAll('#checkout-delivery input:not([type=checkbox]), #checkout-delivery select').forEach(function(el) {
                var field_name = el.id,
                    billing_field_name = field_name.replace('delivery-', 'billing-'),
                    billing_field = document.getElementById(billing_field_name);

                if (billing_field) {
                    el.value = billing_field.value;
                }
            });

            var delivery_zip = document.getElementById('checkout-delivery-zip').value;
            if (delivery_zip) {
                getTimesForZip(delivery_zip);
            }

            document.querySelector('#checkout-delivery-address-confirmation p').innerHTML = document.querySelector('#checkout-billing-address-confirmation p').innerHTML;
            document.getElementById('checkout-delivery-address-confirmation').classList.remove('hidden');
        }
    });
}

if (document.querySelector('#checkout-pickup-location')) {
    document.getElementById('checkout-pickup-location').addEventListener('change', function() {
        if (this.options[this.selectedIndex].value === '0') {
            document.getElementById('checkout-pickup-location-address').innerHTML = '';

            return;
        }
        var addressAndNotes = this.options[this.selectedIndex].getAttribute('data-address');
        if (this.options[this.selectedIndex].getAttribute('data-notes').length) {
            addressAndNotes += '<br>' + this.options[this.selectedIndex].getAttribute('data-notes');
        }
        document.getElementById('checkout-pickup-location-address').innerHTML = addressAndNotes;

        var request = new XMLHttpRequest();
        request.open('POST', '/cart/setOption', true);
        request.onload = function() {
            if (request.status >= 200 && request.status < 400) {
                var cartResponse = JSON.parse(this.responseText);
                updateCartDisplay(cartResponse);
            } else {
                alertMessage('AJAX response error in switching checkout delivery type', request);
            }
        };
        request.error = function() {
            alertMessage('Server response error in switching checkout delivery type', request);
        };

        var changeFD = new FormData();
        changeFD.append('option', 'pickuplocation_id');
        changeFD.append('value', this.value);

        request.send(changeFD);
    });
}


/*
    Area: Guest checkout
    Trigger: email address in registration/billing fields
    Check: Does the email address entered have an account? If so, redirect.
*/
(function() {
    var ticking = false;
    document.querySelectorAll('.checkout-email-requires-nonexisting-account').forEach(function (el) {
        el.addEventListener('change', function() {
            if (!ticking) {
                window.requestAnimationFrame(function() {
                    var request = new XMLHttpRequest();
                    request.open('POST', '/store/customers/checkemail', true);
                    request.onload = function() {
                        if (request.status >= 200 && request.status < 400) {
                            var response = JSON.parse(this.responseText);
                            if (response.accountFound) {
                                el.classList.add('error');
                                el.nextElementSibling.classList.remove('hidden');
                            } else {
                                el.classList.remove('error');
                                el.nextElementSibling.classList.add('hidden');
                            }
                        } else {
                            alertMessage('AJAX response error in validating new account email', request);
                        }
                    };
                    request.error = function() {
                        alertMessage('Server response error in validating new account email', request);
                    };

                    var validationFD = new FormData();
                    validationFD.append('email', el.value);
                    request.send(validationFD);

                    ticking = false;
                });
            }
            ticking = true;
        });
    });
}());

/*
    Area: checkout
    Trigger: email address
    Action: set the "Create an account" email to the checkout email.
*/
/*if (document.getElementById('checkout-email')) {
    document.getElementById('checkout-email').addEventListener('change', function() {
        document.getElementById('create-account-email').value = this.value;
    });
}*/


function disableButton(btn, text = '') {
    btn.classList.add('disabled');
    btn.setAttribute('disabled', 'disabled');
    btn.setAttribute('data-originaltext', btn.value);
    if (text) {
        btn.value = text;
    }
}
function enableButton(btn) {
    btn.classList.remove('disabled');
    btn.removeAttribute('disabled');
    btn.value = btn.getAttribute('data-originaltext');
}

var checkoutForm = document.getElementById('checkout-form');
if (checkoutForm) {
    braintree.dropin.create({
        authorization: document.getElementById('braintree_client_token').value,
        container: '#card-element',
        paypal: {
            flow: 'vault'
        }
    }, function (createErr, instance) {
        document.getElementById('place-order-button').addEventListener('click', function () {
            const submitButton = this;
            disableButton(submitButton, "Processing");

            var deliveryConfirmation = document.getElementById('delivery_instructions_confirmed');
            var pickupConfirmation = document.getElementById('pickup_instructions_confirmed');

            if (document.getElementById('checkout_delivery_pickup').checked) {
                    if (pickupConfirmation && !pickupConfirmation.checked) {
                    alert("Please confirm your pickup date.");
                    enableButton(submitButton);
                    return false;
                }
            }

            if (document.getElementById('checkout_delivery_delivery').checked) {
                    if (deliveryConfirmation && !deliveryConfirmation.checked) {
                    alert("Please confirm your delivery date.");
                    enableButton(submitButton);
                    return false;
                }
            }

            if (document.getElementById('checkout_delivery_pickup').checked && document.getElementById('checkout-pickup-location').value === '0') {
                alert("Please choose a pickup location.");
                enableButton(submitButton);
                return false;
            }

            var requiredFields;
            if (document.getElementById('checkout_delivery_delivery').checked) {
                requiredFields = [
                    'billing-first-name', 'billing-last-name', 'billing-address-1', 'billing-city', 'billing-state', 'billing-zip', 'email', 'phone',
                    'delivery-first-name', 'delivery-last-name', 'delivery-address-1', 'delivery-city', 'delivery-state', 'delivery-zip'
                ];
            } else {
                requiredFields = [
                    'billing-first-name', 'billing-last-name', 'billing-address-1', 'billing-city', 'billing-state', 'billing-zip', 'email', 'phone'
                ];
            }

            var failedFields = [];
            requiredFields.forEach(function(fieldName) {
                var originalFieldName = fieldName;
                fieldName = 'checkout-' + fieldName;
                var field = document.getElementById(fieldName);
                if (field.value.trim().length === 0) {
                    failedFields.push(originalFieldName);
                }
            });
            if (failedFields.length) {
                failedFields = failedFields.map(function(name) {
                    return name.replace(/-/ig, ' ', name).split(' ').map(function(w) {
                        return w[0].toUpperCase() + w.substr(1).toLowerCase();
                    }).join(' ');
                });
                alert("Please fill out all required fields: " + failedFields.join(', '));
                enableButton(submitButton);
                return false;
            }


            if (parseFloat(globalCart.grandTotal) === 0) {
                checkoutForm.submit();
            } else {
                instance.requestPaymentMethod(function (requestPaymentMethodErr, payload) {
                    if (requestPaymentMethodErr) {
                        alert("Please check your payment information and try again.");
                        enableButton(submitButton);
                        return;
                    }
                    document.getElementById('payment_method_nonce').value = payload.nonce;
                    checkoutForm.submit();
                });
            }
        });
    });
}


var redeemGCButton = document.getElementById('redeem-gift-card');
if (redeemGCButton) {

    document.getElementById('gift-card-check-field').addEventListener('keyup', function(e) {
        if (e.keyCode === 13) {
            redeemGCButton.click();
        }
    });

    redeemGCButton.addEventListener('click', function() {
        var cardCode = document.getElementById('gift-card-check-field').value.trim();

        if (!cardCode.length) {
            alert("Please enter a gift card code to check.");
            return false;
        }

        redeemGCButton.setAttribute('disabled', 'disabled');
        redeemGCButton.classList.add('disabled');

        var request = new XMLHttpRequest();
        request.open('POST', '/store/cart/redeemGiftCard', true);
        request.onload = function() {
            if (request.status >= 200 && request.status < 400) {
                var response = JSON.parse(this.responseText);
                if (response.status !== "OK") {
                    alert("Sorry, that gift card isn't valid. Try again.");
                    redeemGCButton.removeAttribute('disabled');
                    redeemGCButton.classList.remove('disabled');
                } else {
                    window.location.reload();
                }
            } else {
                alertMessage('AJAX response error in checking gift card', request);
                redeemGCButton.removeAttribute('disabled');
                redeemGCButton.classList.remove('disabled');
            }
        };
        request.error = function() {
            alertMessage('Server response error in checking gift card', request);
            redeemGCButton.removeAttribute('disabled');
            redeemGCButton.classList.remove('disabled');
        };

        var gcFD = new FormData();
        gcFD.append('code', cardCode);
        request.send(gcFD);
    });
}


var premiumItemExplanationButton = document.getElementById('premium-explanation-button');
var premiumItemExplanationText = document.getElementById('premium-explanation-details');

function showPremiumItemExplanation() {
    premiumItemExplanationText.classList.remove('hidden');
}
function hidePremiumItemExplanation() {
    premiumItemExplanationText.classList.add('hidden');
}
if (premiumItemExplanationButton) {
    premiumItemExplanationButton.addEventListener('mouseenter', showPremiumItemExplanation);
    premiumItemExplanationButton.addEventListener('click', showPremiumItemExplanation);

    premiumItemExplanationText.addEventListener('mouseenter', showPremiumItemExplanation);
    premiumItemExplanationText.addEventListener('mouseleave', hidePremiumItemExplanation);

    premiumItemExplanationButton.addEventListener('mouseleave', hidePremiumItemExplanation);
}


// var googleScript = document.createElement('script');
// googleScript.setAttribute('src', 'https://maps.googleapis.com/maps/api/js?key=' + googleApiKey + '&libraries=places&callback=initLookupMap');
// document.body.appendChild(googleScript);

/* exported initCheckoutLookupMap */ // Actually not exported, but used as a callback.
/* global initCheckoutSetupLookupMap */
function initCheckoutLookupMap() {

    if (window.initCheckoutSetupLookupMap) {
        initCheckoutSetupLookupMap();
    }

    if (!document.getElementById('delivery-autocomplete')) { return; }

    var deliveryAutocompleter = new google.maps.places.Autocomplete(document.getElementById('delivery-autocomplete'), {
        componentRestrictions: { country: 'us' },
        origin: { lat: -72.74379350000001, lng: 41.31777181346496 },
        fields: ['address_component', 'geometry.location']
    });

    deliveryAutocompleter.addListener('place_changed', function() {
        var resultLocation = deliveryAutocompleter.getPlace();
        if (!resultLocation || !resultLocation.address_components) { return; } //Did not get an object back from google.

        var streetNumber = findGoogleAddressComponent(resultLocation, 'street_number');
        var streetName = findGoogleAddressComponent(resultLocation, 'route');
        var cityName = findGoogleAddressComponent(resultLocation, 'locality');
        var stateName = findGoogleAddressComponent(resultLocation, 'administrative_area_level_1');
        var zip = findGoogleAddressComponent(resultLocation, 'postal_code');

        var deliveryZipXhr = new XMLHttpRequest();
        deliveryZipXhr.open('POST', '/store/cart/validateDeliveryZip', true);
        deliveryZipXhr.onload = function() {
            if (deliveryZipXhr.status >= 200 && deliveryZipXhr.status < 400) {
                var response = JSON.parse(this.responseText);
                if (response.status !== 'OK') {
                    alert("Sorry, The Strong Kitchen doesn't deliver to your zip code at this time. Try picking up at one of our convenient partners!");
                    document.getElementById('delivery-autocomplete').value = '';
                    document.getElementById('delivery-autocomplete').focus();
                    return;
                } else {
                    document.getElementById('checkout-delivery-address-1').value = streetNumber + " " + streetName;
                    document.getElementById('checkout-delivery-city').value = cityName;
                    document.getElementById('checkout-delivery-state').value = stateName;
                    document.getElementById('checkout-delivery-zip').value = zip;

                    document.getElementById('checkout-delivery-lat').value = resultLocation.geometry.location.lat();
                    document.getElementById('checkout-delivery-lng').value = resultLocation.geometry.location.lng();

                    document.querySelector('#checkout-delivery-address-confirmation p').innerHTML = streetNumber + ' ' + streetName + '<br>' + cityName + ', ' + stateName + ' ' + zip;
                    document.getElementById('checkout-delivery-address-confirmation').classList.remove('hidden');
                }
            }
        };
        var validationFD = new FormData();
        validationFD.append('zipcode', zip);
        deliveryZipXhr.send(validationFD);
    });

    var billingAutocompleter = new google.maps.places.Autocomplete(document.getElementById('billing-autocomplete'), {
        componentRestrictions: { country: 'us' },
        origin: { lat: -72.74379350000001, lng: 41.31777181346496 },
        fields: ['address_component', 'geometry.location']
    });

    billingAutocompleter.addListener('place_changed', function() {
        var resultLocation = billingAutocompleter.getPlace();
        if (!resultLocation || !resultLocation.address_components) { return; } //Did not get an object back from google.

        var streetNumber = findGoogleAddressComponent(resultLocation, 'street_number');
        var streetName = findGoogleAddressComponent(resultLocation, 'route');
        var cityName = findGoogleAddressComponent(resultLocation, 'locality');
        var stateName = findGoogleAddressComponent(resultLocation, 'administrative_area_level_1');
        var zip = findGoogleAddressComponent(resultLocation, 'postal_code');

        document.getElementById('checkout-billing-address-1').value = streetNumber + " " + streetName;
        document.getElementById('checkout-billing-city').value = cityName;
        document.getElementById('checkout-billing-state').value = stateName;
        document.getElementById('checkout-billing-zip').value = zip;

        document.getElementById('checkout-billing-lat').value = resultLocation.geometry.location.lat();
        document.getElementById('checkout-billing-lng').value = resultLocation.geometry.location.lng();

        document.querySelector('#checkout-billing-address-confirmation p').innerHTML = streetNumber + ' ' + streetName + '<br>' + cityName + ', ' + stateName + ' ' + zip;
        document.getElementById('checkout-billing-address-confirmation').classList.remove('hidden');
    });

    confirmBillingCoords();

}

function confirmBillingCoords() {
    if (!document.getElementById('checkout-billing-lat')) { return; }
    if (document.getElementById('checkout-billing-lat').value.length === 0 || document.getElementById('checkout-billing-lng').value.length === 0) {
        var request = {
            query: document.getElementById('checkout-billing-address-1').value + ' ' + document.getElementById('checkout-billing-city').value + ', ' + document.getElementById('checkout-billing-state').value + ' ' + document.getElementById('checkout-billing-zip').value,
            fields: ['formatted_address', 'geometry.location']
        };

        if (request.query.trim().length === 1) { return; }

        var svc = new google.maps.places.PlacesService(document.createElement('div'));
        svc.findPlaceFromQuery(request, function(results, status) {
            if (status === google.maps.places.PlacesServiceStatus.OK) {
                document.getElementById('checkout-billing-lat').value = results[0].geometry.location.lat();
                document.getElementById('checkout-billing-lng').value = results[0].geometry.location.lng();
            }
        });
    }
}

function resetDateText(data) {
	document.querySelectorAll('input[name=delivery_date]').forEach(function(dateInput) {
        if (dateInput.value.toLowerCase().startsWith(data[0])) {
            dateInput.checked = true;
            var dates = document.getElementsByClassName('delivery_date');
            for (var date of dates) {
            	date.innerText = dateInput.value;
            }
        } else {
            dateInput.checked = false;
        }
    });
    if (data[1] === "afternoon") {
        document.getElementById("nav_delivery_early").style.display = "inline";
        document.getElementById("nav_delivery_normal").style.display = "none";
        document.getElementById("delivery_early_hours").style.display = "inline";
        document.getElementById("delivery_normal_hours").style.display = "none";
    } else {
        document.getElementById("nav_delivery_early").style.display = "none";
        document.getElementById("nav_delivery_normal").style.display = "inline";
        document.getElementById("delivery_early_hours").style.display = "none";
        document.getElementById("delivery_normal_hours").style.display = "inline";
    }

    document.querySelectorAll('input[name=delivery_timeframe]').forEach(function(timeInput) {
        if (timeInput.id.endsWith(data[1])) {
            timeInput.checked = true;
        } else {
            timeInput.checked = false;
        }
    });
    document.getElementById("pickup_instructions_confirmed").checked = false;
    document.getElementById("delivery_instructions_confirmed").checked = false;
}

var initial = document.getElementById('afternoon_select');
if (initial) {
    resetDateText(initial.value.split("_"));
}

if (document.querySelector('#afternoon_select')) {
    document.querySelector('#afternoon_select').addEventListener('change', function(afternoonInput) {
        resetDateText(afternoonInput.target.value.split("_"));
    });
}

document.querySelectorAll('input[name=checkout_delivery_type]').forEach(function(input) {
    input.addEventListener('click', function() {
        var types = document.getElementsByClassName('delivery_type');
        for (var type of types) {
            type.innerText = input.value;
        }
        var deliveryConfirmation = document.getElementById('delivery_instructions_confirmed');
        var pickupConfirmation = document.getElementById('pickup_instructions_confirmed');
        var deliveryNormal = document.getElementById('delivery_normal');
        var deliveryMorning = document.getElementById('delivery_morning');
        var deliveryHours = document.getElementById('delivery_hours');
        var deliveryZip = document.getElementById('checkout-delivery-zip');

        if (input.value === 'pickup') {
            if (deliveryConfirmation) {
                deliveryConfirmation.disabled = true;
                deliveryConfirmation.selected = false;
            }
            if (pickupConfirmation) {
                pickupConfirmation.disabled = false;
                pickupConfirmation.selected = false;
            }
            if (deliveryConfirmation) {
                deliveryNormal.click();
            }
            if (deliveryMorning) {
                deliveryMorning.click();
            }
            if (deliveryHours) {
                deliveryHours.style.display = "none";
            }
            resetDateText(["monday", "morning"]);
        } else {
            if (deliveryConfirmation) {
                deliveryConfirmation.disabled = false;
                deliveryConfirmation.selected = false;
            }
            if (pickupConfirmation) {
                pickupConfirmation.disabled = true;
                pickupConfirmation.selected = false;
            }
            if (deliveryHours) {
                deliveryHours.style.display = "inline";
            }
            if (deliveryZip) {
                getTimesForZip(deliveryZip.value);
            }
        }
    });
});

if (document.querySelector('#cooler_bag')) {
    document.querySelector('#cooler_bag').addEventListener('click', function() {
        var checkboxField = this;

        var subtotal = Number(document.getElementById("overview-cart-subtotal").innerText);
        var tax = Number(document.getElementById("overview-cart-tax").innerText);
        var grand_total = Number(document.getElementById("overview-cart-grandtotal").innerText);
        var cooler_cost = Number(document.getElementById("coolerCost").innerText);
        var cooler_tax = Number(number_format(cooler_cost * 0.0635, 2));

        if (checkboxField.checked) {
            subtotal += cooler_cost;
            tax += cooler_tax;
            grand_total += (cooler_cost + cooler_tax);
        } else {
            subtotal -= cooler_cost;
            tax -= cooler_tax;
            grand_total -= (cooler_cost + cooler_tax);
        }
        document.getElementById("overview-cart-subtotal").innerText = number_format(subtotal, 2);
        document.getElementById("item_total").value = number_format(subtotal, 2);
        document.getElementById("overview-cart-tax").innerText = number_format(tax, 2);
        document.getElementById("tax").value = number_format(tax, 2);
        document.getElementById("overview-cart-grandtotal").innerText = number_format(grand_total, 2);
        document.getElementById("grand_total").value = number_format(grand_total, 2);
    });
}

var coolerExplanationButton = document.getElementById('cooler-explanation-button');
var coolerExplanationText = document.getElementById('cooler-explanation-details');

function showCoolerExplanation() {
    coolerExplanationText.classList.remove('hidden');
}
function hideCoolerExplanation() {
    coolerExplanationText.classList.add('hidden');
}
if (coolerExplanationButton) {
    coolerExplanationButton.addEventListener('mouseenter', showCoolerExplanation);
    coolerExplanationButton.addEventListener('click', showCoolerExplanation);

    coolerExplanationText.addEventListener('mouseenter', showCoolerExplanation);
    coolerExplanationText.addEventListener('mouseleave', hideCoolerExplanation);

    coolerExplanationButton.addEventListener('mouseleave', hideCoolerExplanation);
}

function validateDeliveryAvailability(delivery_options) {
    var afternoon_select = document.getElementById('afternoon_select');
    if (afternoon_select) {
        for (var i = 1; i < afternoon_select.options.length; i++) {
    	    if (delivery_options.includes(afternoon_select.options[i].value)) {
    	        afternoon_select.options[i].style.display = "inline";
    	        afternoon_select.options[i].disabled = false;
    	    } else {
    	        afternoon_select.options[i].style.display = "none";
    	        afternoon_select.options[i].selected = false;
                afternoon_select.options[i].disabled = true;
    	    }
    	}
    	resetDateText(afternoon_select.value.split("_"));
    }
}


function getTimesForZip(zip) {
    const validationFD = new FormData();
    validationFD.append('zipcode', zip);
    fetch('/store/cart/validateDeliveryZip/', {
        method: 'POST',
        body: validationFD
    })
    .then(response => response.json())
    .then(data => {
        if (data.status !== 'OK') {
            alert("Sorry, The Strong Kitchen doesn't deliver to your zip code at this time. Try picking up at one of our convenient partner gyms!");
        }
         else {
            validateDeliveryAvailability(data.options);
        }
    });
}